module.exports = __webpack_public_path__ + "img/balao_balao_6.821d9ecf.png";